import { Card } from '@change-corgi/design-system-legacy/components/content';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';

import { craftStarterEmail } from 'src/app/shared/utils/decisionMaker';

import { AutoAddLabel } from './components/AutoAddLabel';
import { DmAvatar } from './components/DmAvatar';
import { EmailDm } from './components/EmailDm';
import { NameAndTitle } from './components/NameAndTitle';
import { NotifiedOrRespondedStatus } from './components/NotifiedOrRespondedStatus';
import { ReadResponse } from './components/ReadResponse';
import { useDmCards } from './hooks/useDmCards';

export function DmCards() {
	const {
		data: { ask, slug, starterDisplayName, signatureCount, emailDm, decisionMakers, allDmResponses },
		actions: { trackProfileLinkClick, trackEmailDmClick, trackReadResponseClick },
	} = useDmCards();

	return (
		<Box sx={{ overflowY: 'auto' }}>
			{decisionMakers.map(
				({ photo, publiclyVisible, slug: dmSlug, displayName, title, email, id, targetPetitionAssociationData }) => {
					const responses = allDmResponses.filter((response) => response.decisionMaker.id === id);
					const hasResponded = responses.length > 0;
					const isNotified =
						(!!targetPetitionAssociationData?.daysSinceNotified || signatureCount > 9) && !(responses.length > 0);

					let emailHref = 'mailto:';
					if (email) {
						emailHref = craftStarterEmail({
							ask,
							slug,
							dmName: displayName,
							dmEmail: email,
							starterDisplayName,
							signatureCount: signatureCount.toString(),
							emailDm,
						});
					}

					return (
						<Card key={id} my={16} p={12} mx={24}>
							<Box data-testid={`dm-${id}`}>
								<Flex sx={{ alignItems: 'flex-start' }}>
									<DmAvatar displayName={displayName} photo={photo} />

									<Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
										<NameAndTitle
											id={id}
											displayName={displayName}
											title={title}
											dmSlug={dmSlug}
											publiclyVisible={publiclyVisible}
											trackProfileLinkClick={trackProfileLinkClick}
										/>
										<NotifiedOrRespondedStatus
											daysSinceNotified={targetPetitionAssociationData?.daysSinceNotified}
											isNotified={isNotified}
											hasResponded={hasResponded}
										/>
										<EmailDm id={id} email={email} emailHref={emailHref} trackEmailDmClick={trackEmailDmClick} />
										<ReadResponse responses={responses} slug={slug} trackReadResponseClick={trackReadResponseClick} />
									</Box>
								</Flex>
								<AutoAddLabel targetPetitionAssociationData={targetPetitionAssociationData} />
							</Box>
						</Card>
					);
				},
			)}
		</Box>
	);
}
